/*
 *
 * OperationAdditionalInfo
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import PortalTextBlocked from 'Components/PortalTextBlocked'
import formattedMessage, { tooltips, messages } from './languageModule'
import './OperationAdditionalInfo.scss'

const OperationAdditionalInfo = ({ info, isLoading }) => {
  const intl = useIntl()

  const securityTypes = {
    0: 'NO_3DSECURE',
    1: '3DS_FULL',
    2: 'NO_3DSECURE',
    3: '3DS_HALF',
    4: '3DS_FULL',
    5: 'NO_3DSECURE'
  }

  const transactionModes = {
    103: 'Apple Pay',
    216: 'Google Pay',
    327: 'Network Tokenization'
  }

  const fields = {
    maskedPan: info?.maskedPan || '-',
    authorizationCode: info?.authorizationCode || '-',
    authorizationResultCode: info?.resultCode || '-',
    description: info?.description || '-',
    cardCountry: info?.cardCountry && typeof info?.cardCountry === 'string' ? info.cardCountry : '-',
    threeDS: info?.securityType ? securityTypes[info?.securityType] : info?.threeDS || '-',
    rrn: info?.rrn || '-',
    reservationNumber: info?.reservationNumber || '-',
    messageReasonCode: info?.messageReasonCode || '-',
    schemaTID: info?.schemaTID || info?.schemaTid || '-',
    status: messages?.[info?.status] ? intl.formatMessage(messages[info?.status]).toUpperCase() : info?.status || '-',
    transactionId: info?.transaction_id || '-',
    invoiceId: info?.invoiceId || '-',
    installmentQty: info?.installmentQty || '-',
    contractId: info?.contractId|| '-', 
    transactionType: info?.transactionType || '-',
    transactionMode: info?.tokenization ? transactionModes[info?.tokenization] : '-'
  }

  return (
    <div className='text_field_section'>
      {fields &&
        Object.entries(fields).map(([field, value]) => (
          <PortalTextBlocked
            textTooltip={tooltips[`${field}_tooltip`] ? intl.formatMessage(tooltips[`${field}_tooltip`]) : null}
            key={`operation-additional-info-field-${field}`}
            label={formattedMessage[field]}
            value={value || '-'}
            isLoading={isLoading}
            noPadding
          />
        ))}
    </div>
  )
}

OperationAdditionalInfo.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  info: PropTypes.object,
  isLoading: PropTypes.bool
}

OperationAdditionalInfo.defaultProps = {
  // Add here some default propTypes values
  info: {},
  isLoading: false
}

export default OperationAdditionalInfo
